import EmailAddressTextInput from '__components/Inputs/TextInput/presets/EmailAddress';
import { useTranslation } from 'react-i18next';
import { useErrors } from '../../../hooks/useErrors';

type EmailInputProps = {
  value?: string | null;
  onChange: (value: string) => void;
  name: 'error_notification_email' | 'all_notification_email';
  label: string;
  labelInfo?: string;
};

export const EmailInput = ({
  value,
  onChange,
  label,
  labelInfo,
  name,
}: EmailInputProps) => {
  const { t } = useTranslation();

  const { clearError, validate, error } = useErrors(name);

  const handleChange = (v: string) => {
    onChange(v);
    clearError();
  };

  return (
    <EmailAddressTextInput
      value={value}
      label={label}
      labelInfo={labelInfo}
      labelInfoPlacement="top"
      placeholder={t('Enter Email')}
      error={error}
      validate={validate}
      onChange={handleChange}
      margin
    />
  );
};
